import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { useEffect, useState } from 'react';
import { AccountSpecialCondition } from '../../../../../../shared/types/modules/account';
import { AccountSpecialConditionProps } from './props';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../../services/param.service';

export const useAccountSpecialCondition = ({
    data,
    onChangeData,
    onChangeFormik,
}: AccountSpecialConditionProps) => {
    const [specialConditions, setDisabilities] = useState<ISelect[]>([]);

    const onSubmit = (data: AccountSpecialCondition) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        formik?.setFieldValue(
            'hasSpecialCondition',
            data?.hasSpecialCondition || ''
        );
        formik?.setFieldValue(
            'specialCondition',
            (data?.specialCondition as ISelect)?.id || ''
        );
        formik?.setFieldValue('observations', data?.observations || '');
    }, [data]);

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        if (formik.values.hasSpecialCondition === false) {
            formik.setFieldValue('specialCondition', '');
            formik.setFieldValue('observations', '');
        }
    }, [formik.values.hasSpecialCondition]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SPECIAL_CONDITION).then((params) =>
            setDisabilities(params)
        );
    }, []);

    return {
        formik,
        specialConditions,
    };
};
